import type { FaireProductEntity } from "../../entity_types/product";

export const p_9rqyz3ytcf: FaireProductEntity = {
  token: "p_9rqyz3ytcf",
  type: "product",
  name: "Oasis Treasures Dubai Chocolate Bar Gift Box (Fits 4 Bars)",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl:
    "https://cdn.faire.com/fastly/c7e096f867555d640bc695d8df87a5c63ff33fdef37abd00e7d900d0e79adb94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ba7a1440a7d0218198f236cc950a04c961ca822b92fc6d576415bfb7ad535ea.jpeg",
  ],
  priceDollars: 4.14,
  description:
    "Boost Sales with the Oasis Treasures Dubai Chocolate Bar Gift Box!\n\nGive your customers a premium way to present Oasis Treasures Dubai Chocolate Bars with our elegantly designed Gift Box. Perfect for custom assortments, seasonal promotions, and luxury gifting, this sleek packaging adds value to every purchase, making it an easy upsell in your store.\n\n✅ Holds Any 4 Flavors – Create a curated selection from our best-selling chocolate bars.\n✅ Premium Presentation – Elevate the gifting experience with a sophisticated, high-end design.\n✅ Perfect for Retail & Corporate Gifting – A great option for holiday sales, special occasions, and gourmet gift bundles.\n\nStock up now and offer your customers a stylish way to gift their favorite Oasis Treasures flavors!\n\nNote: This is an empty gift box—chocolate bars sold separately.\n\n",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:03.410Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
